/**
 * How wide the crag route editor's two sized columns are, and where that is
 * remembered.
 *
 * Same shape as the scans page — the sectors list and the routes list carry a
 * dragged width, the photo is the elastic column that takes whatever they leave,
 * and the controls panel uses the scans page's own PANEL_WIDTH bounds because
 * `ScanEditorLayout` (shared) is what sizes it.
 *
 * The helpers themselves (`useStoredWidth`, `clampWidth`) are not scans-specific
 * and are imported from there rather than copied; only the keys and the bounds
 * belong to this page.
 */
export const SECTORS_WIDTH_STORAGE_KEY = 'gym_admin_crag_routes_sectors_width';
export const DEFAULT_SECTORS_WIDTH = 240;
export const MIN_SECTORS_WIDTH = 180;
export const MAX_SECTORS_WIDTH = 420;

export const ROUTES_WIDTH_STORAGE_KEY = 'gym_admin_crag_routes_list_width';
export const DEFAULT_ROUTES_WIDTH = 300;
export const MIN_ROUTES_WIDTH = 240;
export const MAX_ROUTES_WIDTH = 620;
